
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, ScrollTracking } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`In verschiedenen Ländern der Welt ist die Migräne etwa gleich häufig – trotz unterschiedlichem Klima. Auch die Kopfschmerztage pro Monat oder Jahr sind recht einheitlich. Bis heute gibt es keinen Beweis, dass das Wetter und Migräneattacken zusammenhängen. Wenige Menschen reagieren aber auf sich schnell ändernde Wetterverhältnisse mit Migräneattacken.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;